
export const getCodigos = (state) => {
    return state.codigos
}

export const getBusCodigos = (state) => (search = '') => {
    //console.log('prueba 1')
    if (search.length === 0) return state.codigos;
    let codigos = []
    if (search.length > 0) {
        //console.log('prueba 2')
        for (let i = 0; i < state.codigos.length; i++) {
            //console.log('prueba 3')
            if (state.codigos[i].cedula.includes(search)) {
                codigos.push(state.codigos[i])
                //console.log('prueba 4')
            }
        }
        if (codigos.length > 0) {
            //console.log('prueba 5')
            return codigos
        } else {
            //console.log('prueba 6')

            return []
        }
    }
}
//state.clubs[i].nombre.toLowerCase().includes(search.toLowerCase())) {
/*


export const getBusclu = (state) => (search = '') => {
    if (search.length === 0) return state.clubs
    let clubs = []
    if (search.length > 0) {
        for (let i = 0; i < state.clubs.length; i++) {
            if (state.clubs[i].nombre.toLowerCase().includes(search.toLowerCase())) {
                clubs.push(state.clubs[i])
            }
        }
        if (clubs.length > 0) {
            return clubs
        } else {
            return []
        }
    }
}


export const getBusId = (state) => (id) => {
    const club = state.clubs.find(club => club.id == id)
    if (!club) return
    return { ...club }
}*/



